import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { OpenLinkById } from '../../../common/services/openlinkbyid';

@Component({
  selector: 'app-help-aboutthe-codification',
  templateUrl: './help-aboutthe-codification.component.html'
})
export class HelpAbouttheCodificationComponent implements OnInit {

  constructor(public commonDataService: CommonDataService,
    private graphQlService: GraphqlService, private openlink: OpenLinkById, private sanitizer: DomSanitizer) { }
  atc_heading;
  atc_desc;
  atc_link;
  pageinitialed = false;
  ngOnInit(): void {
       this.commonDataService.showLoader.next(true);
    this.gethelpaboutthecodificationLabels();
  }
  gethelpaboutthecodificationLabels() {
    this.graphQlService.gethelpaboutthecodificationLabels().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.atc_heading = labels.filter(x => x.key == "atc_heading").map(y => y.value);
        this.atc_desc = labels.filter(x => x.key == "atc_desc").map(y => y.value);
        this.atc_link = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "atc_link").map(y => y.value));
        this.commonDataService.showLoader.next(false);
        this.pageinitialed = true;
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });

  }
  openLinkById(event, isSitesBucket) {
    this.openlink.openLinkById(event, isSitesBucket);
  }
}
